export default {
  newDesign: true,
  parameters: {
    landing_id: "IndoQPr",
    segment: 4,
  },
  title: "Penghasilan pertama anak Anda dimulai di sini | Kodland",
  downtimeUrl: "https://www.kodland.org/id",
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Terima kasih telah mempercayai platform edukasi kami!",
    subtitle:
      "Sayangnya, tablet atau ponsel tidak cocok untuk mengikuti kelas kami. Kami berharap dapat bertemu Anda di kelas berikutnya!",
  },
  quizRotateBySteps: {
    1: {
      type: "age-start",
      title: "Berapa usia anak Anda?",
      image: {
        url: "/welcome/indonesia_profit_desk.jpg",
      },
      imageMobile: {
        url: "/welcome/indonesia_profit_mob.jpg",
      },
    },
    2: {
      question: "Apa yang paling menarik bagi Anda tentang belajar pemrograman?",
      answers: [
        "🚀 Peluang penghasilan tinggi di masa depan",
        "💵 Kesempatan mendapatkan penghasilan pertama",
        "🧠 Mengembangkan logika dan disiplin",
        "✅ Semua jawaban di atas",
      ],
    },
    3: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/latam_profit.png",
      subtitle:
        "«Remaja yang mulai belajar pemrograman sebelum usia 18 tahun dua kali lebih mungkin membangun karier teknologi yang sukses dan mendapatkan penghasilan lebih tinggi di masa depan»<br><br><i>Sumber: Penelitian MIT, Early STEM Education</i>",
      button: "Luar biasa!",
    },
    4: {
      question: "Apa minat utama anak Anda?",
      answers: [
        "🎨 Kreativitas dan seni",
        "🎮 Video game dan gaming",
        "🐾 Hewan dan alam",
        "⚽ Olahraga dan aktivitas fisik",
        "📚 Membaca dan belajar hal baru",
        "🤖 Sains dan teknologi",
      ],
    },
    5: {
      question: "Apakah anak Anda memiliki akses ke komputer atau laptop untuk kelas online?",
      answers: [
        "💻 Ya",
        {
          answer: "😐 Tidak",
          stopAnswer: true,
        },
      ],
    },
    6: {
      title: "Selamat! 🎉",
      typeInfo: "congrats",
      subtitle: "Klik '📆 Pesan kelas' untuk menyelesaikan pendaftaran",
      button: "📆 Pesan kelas",
    },
    7: {
      title: "Pesan kelas gratis",
      type: "one-page-contacts",
      subtitle: "",
      button: "Hampir selesai 🔥",
    },
    8: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    9: {
      title: "Periksa detail ini untuk menyelesaikan pendaftaran ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Untuk kelas ini, Anda membutuhkan PC atau laptop yang berfungsi. Anda juga perlu mendampingi anak selama seluruh sesi berlangsung. Kelas bersifat individual dan disesuaikan dengan kebutuhan anak.",
      button: "Apa lagi?",
    },
    10: {
      title: "Cek email dan WhatsApp Anda sebelum kelas percobaan 📞",
      typeInfo: "whatsapp",
      subtitle:
        "24 jam sebelum kelas, kami akan mengirimkan pengingat. 2 jam sebelum kelas dimulai, kami akan meminta Anda mengonfirmasi kehadiran. Tetap terhubung agar kelas tidak dibatalkan.",
      button: "Apa lagi?",
    },
    11: {
      title: "Kelas akan berlangsung di platform kami 💻",
      typeInfo: "classroom",
      subtitle:
        "Anda akan menerima tautan dan kode unik melalui WhatsApp dan email. Cukup klik tautan tersebut dan Anda akan langsung masuk ke kelas. Tanpa aplikasi tambahan, tanpa unduhan.",
      button: "Mengerti ✅",
    },
  },
};
